/* Größenberater „Finde deine Größe“ (marktr., 03.11.2026), gleich in Praevaleo und insomne.
   Rechnet aus Körpergröße, Gewicht, gewohnter Größe, Körperbau und Passformwunsch eine Größe
   aus der Größentabelle der Marke. Tabellen, Texte und Selektoren kommen aus snippets/size-finder.liquid.
   Die Angaben bleiben im Browser (localStorage „sf-profil“), an der Bestellung landet nur die
   empfohlene Größe als verstecktes Feld _Größenberater, wenn genau diese Größe gekauft wird. */
(function () {
  'use strict';
  var KEY = 'sf-profil';
  var LETTERS = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

  /* ---------- Rechnung (rein, ohne DOM, damit sie sich testen lässt) ---------- */

  // Lage eines Werts zwischen den Mitten der Tabellenzeilen, als Kommazahl (0 = XS, 1 = S …).
  function position(v, centers) {
    var n = centers.length;
    if (v <= centers[0]) return Math.max(-0.6, (v - centers[0]) / (centers[1] - centers[0]));
    if (v >= centers[n - 1]) return Math.min(n - 1 + 0.6, n - 1 + (v - centers[n - 1]) / (centers[n - 1] - centers[n - 2]));
    for (var i = 0; i < n - 1; i++) {
      if (v <= centers[i + 1]) return i + (v - centers[i]) / (centers[i + 1] - centers[i]);
    }
    return n - 1;
  }
  function mid(r) { return (r[0] + r[1]) / 2; }
  function inchOf(label) { var m = /\((\d{2})\)/.exec(label); return m ? +m[1] : null; }

  // p: {sex, h, w, usual, form, fit}; c: Konfiguration; sizes: [{label, available}]
  function compute(p, c, sizes) {
    var t = c.table;
    var hi = position(p.h, t.map(function (r) { return mid(r.h); }));
    var wi = position(p.w, t.map(function (r) { return mid(r.w); }));
    var idx = 0.4 * hi + 0.6 * wi;
    if (p.usual != null && p.usual !== '') {
      var ui = c.cat === 'pants' && c.usualInch ? (+p.usual - c.inchBase) / 2 : LETTERS.indexOf(p.usual);
      if (isFinite(ui) && (ui >= 0 || c.usualInch)) idx = 0.5 * idx + 0.5 * ui;
    }
    if (p.form === 'Schmal') idx -= 0.3;
    if (p.form === 'Breit') idx += 0.3;
    // Bei Hosen sitzt der Bund fest, der Wunsch verschiebt dort nur halb so weit wie bei Oberteilen.
    var fitStep = c.cat === 'pants' ? 0.25 : 0.5;
    if (p.fit === 'Enger') idx -= fitStep;
    if (p.fit === 'Lockerer') idx += fitStep;
    if (p.sex === 'Damen') idx += c.cat === 'pants' ? 0.2 : -0.3;
    idx = Math.max(0, Math.min(LETTERS.length - 1, idx));

    // Hosen mit Zollzahl im Namen (Praevaleo „L (32)“, „L/XL (33)“): nächste Zollzahl, bei Gleichstand die größere.
    var inches = sizes.map(function (s) { return inchOf(s.label); });
    if (c.cat === 'pants' && inches.every(function (x) { return x != null; })) {
      var target = c.inchBase + 2 * idx;
      var order = sizes.map(function (s, i) { return { s: s, d: Math.abs(inches[i] - target), in: inches[i] }; })
        .sort(function (a, b) { return a.d - b.d || b.in - a.in; });
      var best = order[0];
      var wanted = LETTERS[Math.round(idx)] + ' (' + (c.inchBase + 2 * Math.round(idx)) + ')';
      if (best.d > 1.5) return { state: 'missing', label: wanted, range: rangeOf(sizes) };
      var alt = order[1] && order[1].d - best.d < 0.6 ? order[1] : null;
      return finish(best.s, alt && alt.s, alt ? (alt.in > best.in ? 'loose' : 'tight') : null, sizes);
    }

    // Buchstaben: zwischen zwei Größen entscheidet die Regel der Marke je Kategorie.
    var base = Math.floor(idx), frac = idx - base, pick = Math.round(idx), other = null;
    if (frac >= 0.35 && frac <= 0.65 && base + 1 < LETTERS.length) {
      var rule = c.between;
      var up = rule === 'larger' || (rule === 'shoulder' && p.form === 'Breit');
      pick = up ? base + 1 : base;
      other = up ? base : base + 1;
    }
    var find = function (i) { return i == null ? null : sizes.find(function (s) { return s.label === LETTERS[i]; }) || null; };
    var hit = find(pick), alt2 = find(other);
    if (!hit && alt2) return finish(alt2, null, other > pick ? 'loose' : 'tight', sizes, LETTERS[pick]);
    if (!hit) return { state: 'missing', label: LETTERS[pick], range: rangeOf(sizes) };
    return finish(hit, alt2, alt2 ? (other > pick ? 'loose' : 'tight') : null, sizes);
  }
  function finish(hit, alt, dir, sizes, instead) {
    return { state: hit.available ? 'ok' : 'soldout', label: hit.label, alt: alt ? alt.label : null, dir: dir, instead: instead || null, range: rangeOf(sizes) };
  }
  function rangeOf(sizes) { return sizes.length ? sizes[0].label + ' bis ' + sizes[sizes.length - 1].label : ''; }

  /* ---------- Zeichnungen: Schneiderbüste (Oberteile) und Unterkörper (Hosen) ---------- */

  function r1(n) { return Math.round(n * 10) / 10; }
  function L(v) { return r1(50 - v); }
  function R(v) { return r1(50 + v); }
  function bust(f, s, c, w, h) {
    var n = f ? 6 : 7, wy = f ? 70 : 76;
    var out = 'M' + L(n) + ' 4 L' + L(n) + ' 14 C' + L(n) + ' 18 ' + L(s - 8) + ' 19 ' + L(s) + ' 24 C' + L(s + 2) + ' 27 ' + L(s + 1) + ' 34 ' + L(s - 3) + ' 38 C' + L(c) + ' 50 ' + L(c) + ' 58 ' + L(w) + ' ' + wy + ' C' + L(w + 1) + ' 86 ' + L(h) + ' 96 ' + L(h) + ' 110 L' + R(h) + ' 110 C' + R(h) + ' 96 ' + R(w + 1) + ' 86 ' + R(w) + ' ' + wy + ' C' + R(c) + ' 58 ' + R(c) + ' 50 ' + R(s - 3) + ' 38 C' + R(s + 1) + ' 34 ' + R(s + 2) + ' 27 ' + R(s) + ' 24 C' + R(s - 8) + ' 19 ' + R(n) + ' 18 ' + R(n) + ' 14 L' + R(n) + ' 4';
    var neck = 'M' + L(n) + ' 14 C' + L(n - 2) + ' 19 ' + R(n - 2) + ' 19 ' + R(n) + ' 14';
    var chest = f
      ? ' M' + L(c - 3) + ' 54 C' + L(c - 6) + ' 62 ' + L(6) + ' 62 ' + L(2) + ' 57 M' + R(c - 3) + ' 54 C' + R(c - 6) + ' 62 ' + R(6) + ' 62 ' + R(2) + ' 57'
      : ' M' + L(c - 6) + ' 50 C' + L(c - 8) + ' 58 ' + L(4) + ' 58 50 54 C' + R(4) + ' 58 ' + R(c - 8) + ' 58 ' + R(c - 6) + ' 50';
    return [out, neck + chest, 'M50 110 L50 117 M42 117 L58 117'];
  }
  function legs(w, h) {
    return [
      'M' + L(w) + ' 8 C' + L(w + 1) + ' 20 ' + L(h) + ' 30 ' + L(h) + ' 46 C' + L(h) + ' 64 ' + L(h - 3) + ' 88 ' + L(h - 5) + ' 114 M' + R(w) + ' 8 C' + R(w + 1) + ' 20 ' + R(h) + ' 30 ' + R(h) + ' 46 C' + R(h) + ' 64 ' + R(h - 3) + ' 88 ' + R(h - 5) + ' 114',
      'M' + L(w) + ' 8 L' + R(w) + ' 8 M' + L(w) + ' 15 L' + R(w) + ' 15',
      'M46 114 C47 92 48 76 50 66 C52 76 53 92 54 114'
    ];
  }
  function figures(pants, fem) {
    if (pants) return (fem ? [[15, 23], [17, 28], [19, 33]] : [[18, 22], [21, 26], [24, 31]]).map(function (d) { return legs(d[0], d[1]); });
    return (fem ? [[25, 21, 15, 21], [28, 24, 18, 25], [32, 28, 22, 29]] : [[28, 22, 17, 19], [32, 26, 21, 22], [37, 31, 25, 25]])
      .map(function (d) { return bust(fem, d[0], d[1], d[2], d[3]); });
  }

  var api = { compute: compute, figures: figures, rec: null, props: function () { return {}; } };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  window.SizeFinder = api;

  /* ---------- Oberfläche ---------- */

  function esc(s) { return String(s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || 'null') || {}; } catch (e) { return {}; } }
  function save(p) { try { localStorage.setItem(KEY, JSON.stringify(p)); } catch (e) {} }

  function init() {
    var cfgEl = document.querySelector('[data-sf-config]');
    if (!cfgEl) return;
    var c;
    try { c = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var T = c.text;
    var sizes = c.sizes;
    var profile = load();
    // Körperbau gilt je Oberteil oder Hose; die gewohnte Größe bei Zoll-Hosen (Jeans) getrennt von Buchstaben-Hosen (Jogger).
    var catKey = c.cat === 'pants' ? 'pants' : 'top';
    var usualKey = c.cat === 'pants' && c.usualInch ? 'zoll' : catKey;
    var startUrl = (window.performance && performance.getEntriesByType && (performance.getEntriesByType('navigation')[0] || {}).name) || location.href;
    var steps = (c.askSex ? ['wen'] : []).concat(['hoehe', 'gewicht', 'gewohnt', 'form', 'passform']);
    var state = null; // Arbeitskopie während des Quiz
    var result = null;
    var triggers = [].slice.call(document.querySelectorAll('[data-sf-open]'));
    var guide = document.querySelector(c.guideSel);

    function chips() { return [].slice.call(document.querySelectorAll(c.chipSel)); }
    function chipVal(el) { return c.chipAttr === 'value' ? el.value : el.getAttribute(c.chipAttr); }
    function selectSize(label) {
      chips().forEach(function (el) {
        if (chipVal(el) !== label) return;
        if (c.selectMode === 'radio') { el.checked = true; el.dispatchEvent(new Event('change', { bubbles: true })); }
        else if (!el.classList.contains('is-active')) el.click();
      });
    }
    function markChips() {
      chips().forEach(function (el) {
        var box = c.markSel ? el.closest(c.markSel) : el;
        if (box) box.classList.toggle('sf-is-rec', !!result && result.state !== 'missing' && chipVal(el) === result.label);
      });
    }
    function updateTriggers() {
      triggers.forEach(function (b) {
        var has = result && result.state !== 'missing';
        b.querySelector('[data-sf-label]').textContent = has ? T.yourSize + ': ' + result.label : T.open;
        b.classList.toggle('sf-has', !!has);
      });
    }
    function answered(p) { return !!(p && p.h && p.w && p.form && p.form[catKey] && p.usual && usualKey in p.usual); }
    function refreshStock() {
      if (!c.oosClass) return;
      chips().forEach(function (el) {
        var box = c.markSel ? el.closest(c.markSel) : el;
        var s = sizes.find(function (x) { return x.label === chipVal(el); });
        if (s && box) s.available = !box.classList.contains(c.oosClass);
      });
    }
    // Eine Empfehlung gibt es erst, wenn diese Kategorie (Oberteil oder Hose) beantwortet ist.
    function recompute(p) {
      if (!answered(p)) { result = null; api.rec = null; return; }
      refreshStock();
      result = compute({ sex: p.sex, h: p.h, w: p.w, usual: p.usual[usualKey], form: p.form[catKey], fit: p.fit }, c, sizes);
      api.rec = result.state === 'missing' ? null : result.label;
    }
    api.props = function (options) {
      if (!api.rec || !options || options.indexOf(api.rec) < 0) return {};
      var o = {}; o[c.propKey] = api.rec; return { properties: o };
    };

    // Beim Laden: Wer das Quiz schon gemacht hat, sieht seine Größe vorgewählt und markiert.
    recompute(profile);
    updateTriggers();
    markChips();
    // Nur vorwählen, wenn der Link keine Variante mitbrachte (die Themes schreiben ?variant= selbst, darum die Adresse beim Laden).
    if (result && result.state === 'ok' && !/[?&]variant=/.test(startUrl)) selectSize(result.label);

    /* Fenster */
    var dlg = document.createElement('dialog');
    dlg.className = 'sf';
    dlg.setAttribute('aria-labelledby', 'sf-q');
    dlg.innerHTML =
      '<div class="sf__top"><button type="button" class="sf__ic" data-sf-act="back" aria-label="' + esc(T.back) + '"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="sf__ic" data-sf-act="close" aria-label="' + esc(T.close) + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button></div>' +
      '<div class="sf__bar" aria-hidden="true"><span></span></div>' +
      '<div class="sf__body" data-sf-body></div>' +
      '<div class="sf__foot"><button type="button" class="sf__guide" data-sf-act="guide">' + esc(T.guide) + '</button><span class="sf__count" data-sf-count></span></div>';
    document.body.appendChild(dlg);
    var body = dlg.querySelector('[data-sf-body]');
    var bar = dlg.querySelector('.sf__bar');
    var barFill = bar.querySelector('span');
    var count = dlg.querySelector('[data-sf-count]');
    var backBtn = dlg.querySelector('[data-sf-act="back"]');

    function open() {
      var p = load();
      state = {
        step: 0,
        sex: p.sex || null,
        h: p.h || c.defaults.h,
        w: p.w || c.defaults.w,
        usual: (p.usual && p.usual[usualKey]) || null,
        form: (p.form && p.form[catKey]) || null,
        fit: p.fit || null
      };
      // Schon beantwortet: direkt zum Ergebnis. Nur die andere Kategorie (Oberteil statt Hose): ab „gewohnte Größe“.
      if (answered(p)) { recompute(p); state.step = steps.length; }
      else if (p.h && p.w) state.step = steps.indexOf('gewohnt');
      document.documentElement.classList.add('sf-lock');
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      render();
    }
    function close() { if (dlg.open) dlg.close(); }
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('sf-lock'); });
    // Schließen nur bei einem Tipp wirklich außerhalb des Fensters, nicht in seinen Rändern.
    dlg.addEventListener('click', function (e) {
      if (e.target !== dlg) return;
      var r = dlg.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close();
    });

    function head(q, hint) {
      return '<div class="sf__head"><h2 id="sf-q" class="sf__q" tabindex="-1">' + esc(q) + '</h2>' + (c.rule ? '<span class="sf__rule" aria-hidden="true"></span>' : '') + (hint ? '<p class="sf__hint">' + esc(hint) + '</p>' : '') + '</div>';
    }
    function opt(act, val, label, sub, on) {
      return '<button type="button" class="sf__opt' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-sf-act="' + act + '" data-sf-val="' + esc(val) + '"><span><span class="sf__opt-t">' + esc(label) + '</span>' + (sub ? '<span class="sf__opt-s">' + esc(sub) + '</span>' : '') + '</span>' +
        (on ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>' : '') + '</button>';
    }
    function slider(key, unit, min, max) {
      var v = state[key];
      return '<div class="sf__sl"><div class="sf__sl-row"><button type="button" class="sf__round" data-sf-act="minus" aria-label="' + esc(T.less) + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M5 12h14"/></svg></button>' +
        '<div class="sf__val"><span class="sf__num" data-sf-num>' + v + '</span><span class="sf__unit">' + unit + '</span></div>' +
        '<button type="button" class="sf__round" data-sf-act="plus" aria-label="' + esc(T.more) + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M5 12h14M12 5v14"/></svg></button></div>' +
        '<label class="sf__vh" for="sf-range">' + esc(key === 'h' ? T.q.hoehe : T.q.gewicht) + '</label><input id="sf-range" class="sf__range" type="range" min="' + min + '" max="' + max + '" value="' + v + '" data-sf-range="' + key + '">' +
        '<div class="sf__ends"><span>' + min + '</span><span>' + max + '</span></div>' +
        '<button type="button" class="sf__btn" data-sf-act="next">' + esc(T.next) + '</button></div>';
    }

    function render() {
      var i = state.step, name = steps[i];
      var isQ = i < steps.length;
      bar.hidden = !isQ;
      barFill.style.width = (isQ ? Math.round((i + 1) / steps.length * 100) : 100) + '%';
      count.textContent = isQ ? T.count.replace('{n}', i + 1).replace('{t}', steps.length) : '';
      backBtn.style.visibility = i === 0 ? 'hidden' : 'visible';
      var h = '';
      if (name === 'wen') {
        h = head(T.q.wen) + '<div class="sf__list">' + ['Damen', 'Herren'].map(function (v) { return opt('sex', v, v, '', state.sex === v); }).join('') + '</div>';
      } else if (name === 'hoehe') {
        h = head(T.q.hoehe) + slider('h', 'cm', 150, 205);
      } else if (name === 'gewicht') {
        h = head(T.q.gewicht, T.hint.gewicht) + slider('w', 'kg', 40, 130);
      } else if (name === 'gewohnt') {
        var inch = c.cat === 'pants' && c.usualInch;
        var list = inch ? c.usualInch : LETTERS;
        h = head(inch ? T.q.gewohntHose : T.q.gewohnt, inch ? T.hint.gewohntHose : T.hint.gewohnt) +
          '<div class="sf__chipwrap"><div class="sf__chips" style="--sf-cols:' + (list.length > 6 ? 5 : 3) + '">' + list.map(function (v) {
            var on = String(state.usual) === String(v);
            return '<button type="button" class="sf__chip' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-sf-act="usual" data-sf-val="' + esc(v) + '">' + esc(v) + '</button>';
          }).join('') + '</div><button type="button" class="sf__chip" data-sf-act="usual" data-sf-val="">' + esc(T.dontKnow) + '</button></div>';
      } else if (name === 'form') {
        var figs = figures(c.cat === 'pants', state.sex === 'Damen');
        h = head(c.cat === 'pants' ? T.q.formHose : T.q.form, c.cat === 'pants' ? '' : T.hint.form) + '<div class="sf__forms">' +
          ['Schmal', 'Normal', 'Breit'].map(function (v, k) {
            var on = state.form === v;
            return '<button type="button" class="sf__form' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-sf-act="form" data-sf-val="' + v + '"><svg viewBox="0 0 100 120" width="72" height="86" fill="none" stroke="currentColor" stroke-width="' + c.stroke + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + figs[k][0] + '"/><path d="' + figs[k][1] + '"/><path d="' + figs[k][2] + '"/></svg><span>' + v + '</span></button>';
          }).join('') + '</div>';
      } else if (name === 'passform') {
        h = head(T.q.passform) + '<div class="sf__list">' +
          opt('fit', 'Enger', 'Enger', T.fit.enger, state.fit === 'Enger') +
          opt('fit', 'Wie gedacht', 'Wie gedacht', T.fit.normal, state.fit === 'Wie gedacht') +
          opt('fit', 'Lockerer', 'Lockerer', c.cat === 'pants' ? T.fit.lockerHose : T.fit.locker, state.fit === 'Lockerer') + '</div>';
      } else {
        h = renderResult();
      }
      body.innerHTML = h;
      var q = dlg.querySelector('#sf-q');
      if (q) q.focus({ preventScroll: true });
    }

    function renderResult() {
      var r = result;
      var text, btn, act = 'add', dis = false;
      if (r.state === 'missing') {
        text = T.res.missing.replace('{size}', r.label).replace('{title}', c.title).replace('{range}', r.range);
        btn = T.res.browse; act = 'browse';
      } else if (r.state === 'soldout') {
        text = T.res.soldout; btn = T.res.soldoutBtn.replace('{size}', r.label); dis = true;
      } else if (r.instead) {
        text = T.res.instead.replace('{want}', r.instead).replace('{size}', r.label).replace('{dir}', r.dir === 'loose' ? T.res.looser : T.res.tighter);
        btn = T.res.add.replace('{size}', r.label);
      } else {
        text = T.res.ok + (r.alt ? ' ' + (r.dir === 'loose' ? T.res.altLoose : T.res.altTight).replace('{alt}', r.alt) : '');
        btn = T.res.add.replace('{size}', r.label);
      }
      return '<div class="sf__res"><p class="sf__res-for">' + esc(c.title) + '</p><div class="sf__res-size" id="sf-q" tabindex="-1">' + esc(r.label) + '</div>' + (c.rule ? '<span class="sf__rule" aria-hidden="true"></span>' : '') + '<p class="sf__res-t">' + esc(text) + '</p></div>' +
        '<div class="sf__res-btns">' + (act === 'browse' ? '<a class="sf__btn" href="' + esc(c.browseUrl) + '">' + esc(btn) + '</a>' : '<button type="button" class="sf__btn" data-sf-act="add"' + (dis ? ' disabled' : '') + '>' + esc(btn) + '</button>') +
        '<button type="button" class="sf__link" data-sf-act="restart">' + esc(T.res.change) + '</button></div>';
    }

    function go(n) { state.step = n; if (n >= steps.length) finishQuiz(); else if (n === steps.length - 1) refreshStock(); render(); }
    function finishQuiz() {
      var p = load();
      p.sex = state.sex; p.h = state.h; p.w = state.w; p.fit = state.fit;
      p.usual = p.usual || {}; p.usual[usualKey] = state.usual;
      p.form = p.form || {}; p.form[catKey] = state.form;
      save(p);
      recompute(p);
      updateTriggers();
      markChips();
      if (result.state === 'ok') selectSize(result.label);
    }
    function setVal(key, v) {
      var r = dlg.querySelector('[data-sf-range]');
      v = Math.max(+r.min, Math.min(+r.max, v));
      state[key] = v; r.value = v;
      dlg.querySelector('[data-sf-num]').textContent = v;
    }

    dlg.addEventListener('input', function (e) {
      var k = e.target.getAttribute('data-sf-range');
      if (k) setVal(k, +e.target.value);
    });
    dlg.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sf-act]');
      if (!b) return;
      var a = b.getAttribute('data-sf-act'), v = b.getAttribute('data-sf-val');
      var key = steps[state.step] === 'hoehe' ? 'h' : 'w';
      if (a === 'close') close();
      else if (a === 'back') go(state.step >= steps.length ? steps.length - 1 : Math.max(0, state.step - 1));
      else if (a === 'next') go(state.step + 1);
      else if (a === 'minus') setVal(key, state[key] - 1);
      else if (a === 'plus') setVal(key, state[key] + 1);
      else if (a === 'sex') { state.sex = v; go(state.step + 1); }
      else if (a === 'usual') { state.usual = v || null; go(state.step + 1); }
      else if (a === 'form') { state.form = v; go(state.step + 1); }
      else if (a === 'fit') { state.fit = v; go(state.step + 1); }
      else if (a === 'restart') go(0);
      else if (a === 'guide') { close(); if (guide) guide.click(); }
      else if (a === 'add') {
        selectSize(result.label);
        close();
        var add = document.querySelector(c.addSel);
        if (add) setTimeout(function () { add.click(); }, 60);
      }
    });

    triggers.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    // Testlink: ?groesse öffnet das Quiz direkt.
    if (/[?&]groesse\b/.test(location.search)) open();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
